<div class="main__container">

	<breadcrumb></breadcrumb>

	<div class="section__container">
		<div class="box__container titulo__container">
			<p class="titulo">8700 Emergencias</p>
		</div>

		<div class="contenido__box" *ngIf="{ ready: ready$ | async, detalle: detalle$ | async } as data">
			<ng-container *ngIf="data.ready; else loading">
				<div *ngIf="data.detalle" class="html" [innerHtml]="data.detalle.html"></div>
			</ng-container>
		</div>
	</div>
</div>

<!-- Loading template -->
<ng-template #loading>
	<loading></loading>
</ng-template>